<template>
  <div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-900 to-black text-white p-4">
    <div class="w-full max-w-md bg-gray-800 bg-opacity-95 p-10 rounded-2xl shadow-2xl border border-gray-800 backdrop-blur-lg">
      <div class="text-center mb-6">
        <img src="@/assets/logo.svg" alt="Vultric Logo" class="w-32 mx-auto mb-4" />
        <h2 class="text-3xl font-extrabold text-blue-400">Forgot Password</h2>
        <p class="text-gray-300 mt-2">Enter your email to receive a password reset link.</p>
      </div>

      <form @submit.prevent="handleForgotPassword" class="space-y-6">
        <label class="block text-gray-400 mb-2 text-sm font-medium" for="email">Email</label>
        <input id="email" v-model="email" type="email"
          class="w-full p-3 rounded-lg bg-gray-700 bg-opacity-80 border border-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-300 placeholder-gray-400 text-white"
          placeholder="Enter your email" required />

        <button type="submit"
          class="w-full py-3 bg-blue-600 rounded-lg text-lg font-semibold hover:bg-blue-700 transition duration-300 transform hover:scale-105 focus:ring-2 focus:ring-blue-400 focus:outline-none shadow-md">
          Send Reset Link
        </button>
      </form>

      <p class="text-center text-gray-400 mt-6">
        Remembered your password? <router-link to="/login" class="text-blue-400 hover:underline">Login</router-link>
      </p>
    </div>

    <!-- Toast Notifications -->
    <ToastManager ref="toastManager" />
  </div>
</template>

<script>
import axios from 'axios';
import ToastManager from '@/components/ToastManager.vue';

export default {
  name: "ForgotPassword",
  components: {
    ToastManager
  },
  data() {
    return {
      email: ""
    };
  },
  methods: {
    async handleForgotPassword() {
      try {
        await axios.post('https://api.syniac.com:3000/api/password/forgot-password', { email: this.email });
        this.$refs.toastManager.addToast('Password reset link sent! Check your email.', 'success');
      } catch (error) {
        this.$refs.toastManager.addToast('Failed to send reset link. Try again.', 'error');
        console.error(error);
      }
    }
  }
};
</script>
